(() => {
      const AREA_SELECTOR = '.cart__ctas';  
      const CHECKBOX_SELECTOR = '.naku-terms-consent-checkbox';
      const BUTTON_SELECTOR = '[data-naku-checkout]';

     
function syncNakuCheckout(area) {
  if (!area) return;

  const companyCheckbox = area.querySelector(
    '.naku-company-checkbox'
  );

  const isCompany = Boolean(companyCheckbox?.checked);
const companyDetails = area.querySelector('.naku-company-details');

if (companyDetails) {
  companyDetails.open = isCompany;
}
  const b2cBox = area.querySelector('.naku-terms-b2c');
  const b2bBox = area.querySelector('.naku-terms-b2b');

  const b2cCheckbox = b2cBox?.querySelector(
    '.naku-terms-consent-checkbox'
  );

  const b2bCheckbox = b2bBox?.querySelector(
    '.naku-terms-consent-checkbox'
  );

  const button = area.querySelector(BUTTON_SELECTOR);

if (b2cBox && b2bBox && b2cCheckbox && b2bCheckbox) {
  const b2cContainer = b2cBox.closest('.naku-terms-consent');

  if (b2cContainer) {
    b2cContainer.hidden = isCompany;
    b2cContainer.style.display = isCompany ? 'none' : '';
  }

  b2cBox.hidden = isCompany;
  b2bBox.hidden = !isCompany;

  b2cBox.style.display = isCompany ? 'none' : '';
  b2bBox.style.display = isCompany ? '' : 'none';

if (b2cCheckbox.disabled !== isCompany) {
  b2cCheckbox.disabled = isCompany;
}
b2cCheckbox.required = !isCompany;

if (b2bCheckbox.disabled !== !isCompany) {
  b2bCheckbox.disabled = !isCompany;
}
b2bCheckbox.required = isCompany;
}


  const activeCheckbox = isCompany
    ? b2bCheckbox
    : b2cCheckbox;

  if (!button) return;
  
  const cartIsEmpty = button.dataset.cartEmpty === 'true';

  const shouldDisable =
    cartIsEmpty || !activeCheckbox?.checked;

  if (button.disabled !== shouldDisable) {
  button.disabled = shouldDisable;
}

  
const ariaDisabled = shouldDisable ? 'true' : 'false';

if (button.getAttribute('aria-disabled') !== ariaDisabled) {
  button.setAttribute('aria-disabled', ariaDisabled);
}

}

      function syncAreaWithDelay(area) {
        if (!area) return;

        syncNakuCheckout(area);

        requestAnimationFrame(() => {
          syncNakuCheckout(area);
        });

        setTimeout(() => {
          syncNakuCheckout(area);
        }, 50);

        setTimeout(() => {
          syncNakuCheckout(area);
        }, 200);

        setTimeout(() => {
          syncNakuCheckout(area);
        }, 500);
      }

      function syncAllNakuCheckoutAreas() {
        document.querySelectorAll(AREA_SELECTOR).forEach((area) => {
          syncNakuCheckout(area);
        });
      }

  
window.__nakuCompanyClearPromise ??= null;   
async function clearNakuCompanyAttributes() {
  const root = window.Shopify?.routes?.root || '/';

  const attributesToClear = {
    'NAKU - Nazov firmy': '',
    'NAKU - ICO': '',
    'NAKU - DIC': '',
    'NAKU - IC DPH': '',
    'Súhlas s OP B2B': '',
    'Súhlas s obchodnými podmienkami': ''
  };

  const response = await fetch(root + 'cart/update.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      attributes: attributesToClear
    })
  });

  if (!response.ok) {
    throw new Error('Nepodarilo sa vymazať firemné údaje.');
  }

  const cart = await response.json();

  for (const key of Object.keys(attributesToClear)) {
    if ((cart.attributes?.[key] ?? '') !== '') {
      throw new Error('Firemné údaje neboli odstránené.');
    }
  }
}

      if (!window.__nakuTermsConsentV2Initialized) {
        window.__nakuTermsConsentV2Initialized = true;

        ['input', 'change', 'click'].forEach((eventName) => {
          document.addEventListener(
            eventName,
            (event) => {
              const target = event.target;

              if (!(target instanceof Element)) return;
              
if (!target.matches(
  CHECKBOX_SELECTOR + ', .naku-company-checkbox'
)) return;


              const area = target.closest(AREA_SELECTOR);

              if (target.matches('.naku-company-checkbox')) {
  syncNakuCheckout(area);
} else {
  syncAreaWithDelay(area);
}
            },
            true
          );
        });


document.addEventListener('change', (event) => {
  const target = event.target;

  if (!(target instanceof HTMLInputElement)) return;
  if (!target.matches('.naku-company-checkbox')) return;
  if (target.checked) return;
const area = target.closest('.cart__ctas');

area?.querySelectorAll('.naku-company-field').forEach((field) => {
  field.value = '';
});

const b2bConsent = area?.querySelector(
  '.naku-terms-b2b .naku-terms-consent-checkbox'
);

if (b2bConsent) {
  b2bConsent.checked = false;
}
  if (window.__nakuCompanyClearPromise) return;

  const clearPromise = clearNakuCompanyAttributes();

  window.__nakuCompanyClearPromise = clearPromise;

  clearPromise
    .catch((error) => {
      console.error('NAKU – čistenie B2B údajov:', error);
      alert(
        'Firemné údaje sa nepodarilo odstrániť. ' +
        'Skúste to, prosím, znova.'
      );
    })
    .finally(() => {
      if (window.__nakuCompanyClearPromise === clearPromise) {
        window.__nakuCompanyClearPromise = null;
      }
    });
}, true);

        document.addEventListener('shopify:section:load', () => {
          requestAnimationFrame(() => {
            syncAllNakuCheckoutAreas();
          });
        });


        document.addEventListener('shopify:section:select', () => {
          requestAnimationFrame(() => {
            syncAllNakuCheckoutAreas();
          });
        });


        const observer = new MutationObserver((mutations) => {
          const affectedAreas = new Set();

          mutations.forEach((mutation) => {

            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach((node) => {
                if (!(node instanceof Element)) return;

                if (node.matches(AREA_SELECTOR)) {
                  affectedAreas.add(node);
                }

                const closestArea = node.closest(AREA_SELECTOR);

                if (closestArea) {
                  affectedAreas.add(closestArea);
                }

                node.querySelectorAll(AREA_SELECTOR).forEach((area) => {
                  affectedAreas.add(area);
                });
              });
            }


            if (mutation.type === 'attributes') {
              const target = mutation.target;

              if (!(target instanceof Element)) return;

              if (
                target.matches(BUTTON_SELECTOR) ||
                target.matches(CHECKBOX_SELECTOR)
              ) {
                const area = target.closest(AREA_SELECTOR);

                if (area) {
                  affectedAreas.add(area);
                }
              }
            }
          });


          affectedAreas.forEach((area) => {
            requestAnimationFrame(() => {
              syncNakuCheckout(area);
            });
          });
        });


        if (document.body) {
          observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
              'disabled',
              'aria-disabled'
            ]
          });
        }
      }


      syncAllNakuCheckoutAreas();

      requestAnimationFrame(() => {
        syncAllNakuCheckoutAreas();
      });

      setTimeout(() => {
        syncAllNakuCheckoutAreas();
      }, 100);
      
      // NAKU – obnovenie firemných údajov po návrate z pokladne
      // Údaje obnovujeme iba dovtedy, kým zákazník nezačne formulár meniť.

      let nakuRestoreInterrupted = false;
      let nakuSavedCompanyState = null;

      function nakuMarkManualChange(event) {
        const target = event.target;

        if (!(target instanceof Element)) return;

        if (
          target.matches(
            '.naku-company-checkbox, ' +
            '.naku-company-field, ' +
            '.naku-terms-consent-checkbox'
          )
        ) {
          nakuRestoreInterrupted = true;
        }
      }

      document.addEventListener(
        'input',
        nakuMarkManualChange,
        true
      );

      document.addEventListener(
        'change',
        nakuMarkManualChange,
        true
      );

      function nakuApplySavedCompanyState() {
        if (
          nakuRestoreInterrupted ||
          !nakuSavedCompanyState
        ) {
          return;
        }

        const data = nakuSavedCompanyState;

        document.querySelectorAll(AREA_SELECTOR).forEach((area) => {
          const checkbox = area.querySelector(
            '.naku-company-checkbox'
          );

          if (!checkbox) return;

          const nameInput = area.querySelector(
            '#naku-company-name'
          );

          const icoInput = area.querySelector(
            '#naku-company-ico'
          );

          // Nezmeníme údaje, ktoré zákazník už sám upravil.
          if (
            (nameInput?.value &&
              nameInput.value !== data.name) ||
            (icoInput?.value &&
              icoInput.value !== data.ico)
          ) {
            return;
          }

          checkbox.checked = true;

          const values = {
            'naku-company-name': data.name,
            'naku-company-ico': data.ico,
            'naku-company-dic': data.dic,
            'naku-company-icdph': data.vat
          };

          Object.entries(values).forEach(([id, value]) => {
            const field = area.querySelector('#' + id);

            if (field && field.value !== value) {
              field.value = value;
            }
          });

          const b2bConsent = area.querySelector(
            '.naku-terms-b2b ' +
            '.naku-terms-consent-checkbox'
          );

          if (b2bConsent) {
            b2bConsent.checked = true;
          }

          syncNakuCheckout(area);
        });
      }

      async function restoreNakuCompanyFromCart() {
        try {
          const root = window.Shopify?.routes?.root || '/';

          const response = await fetch(
            root + 'cart.js',
            {
              credentials: 'same-origin',
              cache: 'no-store'
            }
          );

          if (!response.ok) {
            throw new Error(
              'Nepodarilo sa načítať košík.'
            );
          }

          const cart = await response.json();
          const attributes = cart.attributes || {};

          const name =
            attributes['NAKU - Nazov firmy'] || '';

          const ico =
            attributes['NAKU - ICO'] || '';

          const isB2B =
            Boolean(name && ico) &&
            attributes['Súhlas s OP B2B'] === 'Áno';

          if (
            !isB2B ||
            nakuRestoreInterrupted
          ) {
            return;
          }

          nakuSavedCompanyState = {
            name: name,
            ico: ico,
            dic: attributes['NAKU - DIC'] || '',
            vat: attributes['NAKU - IC DPH'] || ''
          };

          // Prvé obnovenie
          nakuApplySavedCompanyState();

          // Kontroly po načítaní komponentov Shopify.
          // Po manuálnej zmene sa už údaje neprepisujú.
          [150, 500, 1200, 3000].forEach((delay) => {
            setTimeout(
              nakuApplySavedCompanyState,
              delay
            );
          });

        } catch (error) {
          console.error(
            'NAKU – obnovenie B2B údajov:',
            error
          );
        }
      }

      restoreNakuCompanyFromCart();
    })();